export default class ProgressivePromise extends Promise {
  constructor(executor) {
    const progress = { buffer: [], tracker: null }
    const recordProgress = function (...currentProgress) {
      progress.buffer.push([...currentProgress])
      if (progress.tracker) {
        progress.buffer.forEach(recordedProgress => {
          progress.tracker(...recordedProgress)
        })
        progress.buffer = []
      }
    }
    super((resolve, reject) => executor(resolve, reject, recordProgress))
    this.then = (onFulfilled, onRejected, onProgress) => {
      progress.tracker = onProgress
      if (progress.buffer.length && onProgress) {
        progress.buffer.forEach(recordedProgress => {
          onProgress(...recordedProgress)
        })
        progress.buffer = []
      }
      return super.then(onFulfilled, onRejected)
    }
  }
}
